module.exports = {
    RECOMMENDED_ALL_GET: 'RECOMMENDED_ALL_GET',
    RECOMMENDED_NOW_GET: 'RECOMMENDED_NOW_GET',
    RECOMMENDED_EDITORIAL_GET: 'RECOMMENDED_EDITORIAL_GET',
    RECOMMENDED_PROVIDER_GET: 'RECOMMENDED_PROVIDER_GET',
};
